if (!customElements.get('features-filter-slider')) {
  customElements.define('features-filter-slider', class extends HTMLElement {
    connectedCallback() {
      this.onClick = this.handleClick.bind(this);
      this.onHistory = this.scheduleRefresh.bind(this);
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onHistory);
      this.gridObserver = new MutationObserver(() => this.scheduleRefresh());
      const grid = document.getElementById('ProductGridContainer');
      if (grid) this.gridObserver.observe(grid, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onHistory);
      this.gridObserver?.disconnect();
      this.refreshController?.abort();
      clearTimeout(this.refreshTimer);
    }

    filterValues(params, name) {
      return params.getAll(name).flatMap(value => value.split(','));
    }

    handleClick(event) {
      const link = event.target.closest('.features-filter__link');
      if (!link || !this.contains(link)) return;
      if (link.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      if (!link.hasAttribute('data-filter-clear') && !link.dataset.filterParam) return;

      event.preventDefault();
      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      if (link.hasAttribute('data-filter-clear')) {
        [...params.keys()].filter(name => name.startsWith('filter.')).forEach(name => params.delete(name));
      } else {
        const name = link.dataset.filterParam;
        const value = link.dataset.filterValue;
        const active = this.filterValues(params, name).includes(value);
        params.delete(name);
        if (!active) params.append(name, value);
      }

      const Facets = customElements.get('facet-filters-form');
      if (Facets?.renderPage && document.getElementById('ProductGridContainer') && document.getElementById('product-grid')) {
        Facets.renderPage(params.toString());
        document.querySelectorAll('features-filter-slider').forEach(slider => {
          slider.syncActiveState(params);
          slider.scheduleRefresh();
        });
      } else {
        const url = new URL(window.location.href);
        url.search = params.toString();
        window.location.assign(url.href);
      }
    }

    syncActiveState(params) {
      const hasFilters = [...params.keys()].some(name => name.startsWith('filter.'));
      this.querySelectorAll('.features-filter__link').forEach(link => {
        if (!link.hasAttribute('data-filter-clear') && !link.dataset.filterParam) return;
        const active = link.hasAttribute('data-filter-clear')
          ? !hasFilters
          : this.filterValues(params, link.dataset.filterParam).includes(link.dataset.filterValue);
        link.closest('.features-filter__item').classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    scheduleRefresh() {
      this.refreshController?.abort();
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refreshState(), 120);
    }

    async refreshState() {
      const search = window.location.search;
      this.syncActiveState(new URLSearchParams(search));
      this.refreshController = new AbortController();
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url.href, { signal: this.refreshController.signal });
        if (!response.ok) return;
        const html = await response.text();
        if (!this.isConnected || search !== window.location.search) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('features-filter-slider');
        if (!fresh) return;
        fresh.querySelectorAll('[data-block-id]').forEach(freshItem => {
          const item = [...this.querySelectorAll('[data-block-id]')].find(candidate => candidate.dataset.blockId === freshItem.dataset.blockId);
          if (!item) return;
          item.classList.toggle('is-active', freshItem.classList.contains('is-active'));
          item.classList.toggle('is-disabled', freshItem.classList.contains('is-disabled'));
          const link = item.querySelector('.features-filter__link');
          const freshLink = freshItem.querySelector('.features-filter__link');
          ['href', 'role', 'aria-disabled', 'aria-current', 'data-filter-param', 'data-filter-value', 'data-filter-clear', 'target', 'rel'].forEach(name => {
            if (freshLink.hasAttribute(name)) link.setAttribute(name, freshLink.getAttribute(name));
            else link.removeAttribute(name);
          });
        });
      } catch (error) {
        if (error.name !== 'AbortError') this.syncActiveState(new URLSearchParams(window.location.search));
      }
    }
  });
}
